import React from 'react';

export default function VirtualAccount() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Virtual Account</h1>
      <p className="text-gray-500">Halaman Virtual Account</p>
    </div>
  );
}
